/** * @file TableTh */
<template>
  <th class="table-th js_error_header" :class="{'is-error': isError}">
    <slot />
  </th>
</template>

<script>
export default {
  props: {
    isError: {
      type: Boolean,
      default: false
    }
  }
}
</script>

<style lang="scss" scoped>
@import '@/sass/_config.scss';

.table-th {
  &.is-error {
    background: $BG_ERROR_COLOR;
  }
}
</style>
